import { Route, Routes } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import * as Pages from './page-imports'

export function KyrgyzstanRouter() {
  return (
    <Routes>
      <Route
        index
        element={<Pages.KyrgyzstanMainPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.calendar.base()}
        element={<Pages.KyrgyzstanCalendarPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.selectGuests.base()}
        element={<Pages.KyrgyzstanSelectGuestsPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.selectGuestsBooking.base()}
        element={<Pages.KyrgyzstanSelectGuestsBookingPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.calendarBooking.base()}
        element={<Pages.KyrgyzstanCalendarBookingPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.filters.base()}
        element={<Pages.KyrgyzstanFiltersPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.sort.base()}
        element={<Pages.KyrgyzstanSortPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.searchResult.base()}
        element={<Pages.KyrgyzstanSearchResultPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.searchForm.base()}
        element={<Pages.KyrgyzstanSearchFormPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.searchDirection.base()}
        element={<Pages.KyrgyzstanSearchDirectionPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.detail.base()}
        element={<Pages.KyrgyzstanDetailPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.detailShare.base()}
        element={<Pages.KyrgyzstanDetailPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.detailView.base()}
        element={<Pages.KyrgyzstanDetailViewPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.allAmenities.base()}
        element={<Pages.KyrgyzstanAllAmenitiesPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.booking.base()}
        element={<Pages.KyrgyzstanBookingPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.myOrders.detail.base()}
        element={<Pages.KyrgyzstanOrderDetailPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.myOrders.gallery.base()}
        element={<Pages.KyrgyzstanOrderDetailGalleryPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.myOrders.galleryImage.base()}
        element={<Pages.KyrgyzstanOrderDetailGalleryImagePage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.myOrders.cancelBooking.base()}
        element={<Pages.KyrgyzstanCancelBookingPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.myOrders.cancelBookingSuccess.base()}
        element={<Pages.KyrgyzstanCancelBookingSuccessPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.objects.base()}
        element={<Pages.KyrgyzstanMyObjectsPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.objects.bookings.history.base()}
        element={<Pages.KyrgyzstanObjectBookingsHistoryPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.optionDetail.base()}
        element={<Pages.KyrgyzstanOptionDetailPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.optionDetailView.base()}
        element={<Pages.KyrgyzstanOptionDetailPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.optionDetailGallery.base()}
        element={<Pages.KyrgyzstanOptionDetailGalleryPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.optionDetailGalleryImage.base()}
        element={<Pages.KyrgyzstanOptionDetailGalleryImagePage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.gallery.base()}
        element={<Pages.KyrgyzstanGalleryPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.galleryImage.base()}
        element={<Pages.KyrgyzstanGalleryImagePage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.map.base()}
        element={<Pages.KyrgyzstanMapPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.bestOffers.base()}
        element={<Pages.KyrgyzstanBestOffersPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.collections.base()}
        element={<Pages.KyrgyzstanCollectionsPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.restPlaces.base()}
        element={<Pages.KyrgyzstanRestPlacesPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.objects.edit.step.base()}
        element={<Pages.KyrgyzstanEditObjectStepPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.objects.edit.base()}
        element={<Pages.KyrgyzstanEditObjectPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.objects.draftRevision.step.base()}
        element={<Pages.KyrgyzstanRejectedObjectEditStepPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.objects.draftRevision.base()}
        element={<Pages.KyrgyzstanRejectedObjectEditPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.objects.create.base()}
        element={<Pages.KyrgyzstanCreateObjectIntroPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.objects.create.submitted.base()}
        element={<Pages.KyrgyzstanCreateObjectSubmittedPage />}
      />

      <Route
        path={RoutingPaths.kyrgyzstan.objects.create.step.base()}
        element={<Pages.KyrgyzstanCreateObjectPage />}
      />
    </Routes>
  )
}
